import {combineReducers} from 'redux';
import customizationReducer from './customizationReducer';
import snackbarReducer from './snackbarReducer';
import quyenTruyCap from './redux-reducer/quyenTruyCap'
import roleUser from './redux-reducer/roleUser'
import nguoiDung from './redux-reducer/nguoiDung'
import displayModal from "./redux-reducer/displayModal" 
const reducer = combineReducers({
    customization: customizationReducer,
    snackbar: snackbarReducer,
    quyenTruyCap:quyenTruyCap,
    roleUser:roleUser,
    nguoiDung:nguoiDung,
    displayModal:displayModal,
});

export default reducer;
